export default __webpack_public_path__ + "static/media/11.d9c48b3d.webp";